type LayoutConfig =
  | {
      layout: 'center';
      centeredDirection: 'row';
    }
  | {
      layout: 'space-between';
      centeredDirection: 'row' | 'row-reverse';
    };

interface CustomizationOptions {
  enabledAuthTypes: [AuthType, AuthType?];
  loginPageThirdPartyAuths: string[];
  moreOptionsThirdPartyAuths: string[];
  isPasskeyEnabled: boolean;
  layoutConfig?: LayoutConfig;
  componentConfig: {
    banner?: {
      titleKey?: string;
      descKey?: string;
      images?: string[];
    };
  };
}

export const CUSTOMIZATION_MAP = new Map<string, CustomizationOptions>([
  [
    'default',
    {
      // 允许授权的类型
      enabledAuthTypes: ['email', 'phone'],
      // 登录页展示的第三方授权方式
      loginPageThirdPartyAuths: ['google', 'msn'],
      // more options 页面展示的第三方授权方式
      moreOptionsThirdPartyAuths: ['apple', 'facebook'],
      // 是否启用 passkey 登录
      isPasskeyEnabled: true,
      componentConfig: {
        banner: {
          titleKey: 'brand_title',
          descKey: 'brand_description',
        },
      },
      layoutConfig: {
        layout: 'center',
        centeredDirection: 'row',
      },
    },
  ],
  // ==== C APP ====
  [
    'lRna1TwOAXnS3uRunay49ML4fWWsliijZcU57v0Xw42AOnrzKRVIhf5FvRY2O8SC',
    {
      enabledAuthTypes: ['email'],
      loginPageThirdPartyAuths: [],
      moreOptionsThirdPartyAuths: [],
      isPasskeyEnabled: false,
      componentConfig: {},
    },
  ],
  [
    'ZjY5wUpBfVB8s162pkkVxdMmbf9R8qSJN6hOqiBb9swBg6VvtIDaeJRn1Yz7URZr',
    {
      enabledAuthTypes: ['email'],
      loginPageThirdPartyAuths: [],
      moreOptionsThirdPartyAuths: [],
      isPasskeyEnabled: false,
      componentConfig: {},
    },
  ],
  // ==== C APP end ====

  // sample
  [
    'f144af99ebde16eb9718c6c7b6ef6c59546a1775dfe668cea603aff7178e5983',
    {
      enabledAuthTypes: ['phone'],
      loginPageThirdPartyAuths: ['facebook', 'msn'],
      moreOptionsThirdPartyAuths: ['google'],
      isPasskeyEnabled: true,
      componentConfig: {
        banner: {
          titleKey: 'brand_title',
          descKey: 'brand_description',
          images: ['banner.png'],
        },
      },
      layoutConfig: {
        layout: 'center',
        centeredDirection: 'row',
      },
    },
  ],
]);

export const DEFAULT_CUSTOMIZATION = CUSTOMIZATION_MAP.get('default')!;
